module.exports = __webpack_public_path__ + "img/offer-ecom.196fb38a.jpg";